// ─── Supported locales ─────────────────────────────────────────────────────────
// This list mirrors your next-intl config.
// Native name = shown in UI, code = used as locale param.

export interface LangEntry {
  code: string;
  native: string;
  english: string;
}

export const LANGUAGES: LangEntry[] = [
{ code: "ar-AR",  native: "العربية",   english: "Arabic" },
{ code: "en-US",  native: "English",   english: "English" },
{ code: "es-MX",  native: "Español",   english: "Spanish" },
{ code: "fr-FR",  native: "Français",  english: "French" },
{ code: "hi-IN",  native: "हिन्दी",    english: "Hindi" },
{ code: "pt-BR",  native: "Português", english: "Portuguese" },
{ code: "ru-RU", native: "Русский",   english: "Russian" },
{ code: "ko-KR",  native: "한국어",     english: "Korean" },
{ code: "ja-JP",  native: "日本語",     english: "Japanese" },
];
